<template>
  <span class="MSG" @click.once="playSound()"
    >CLICK ME
    <ov-tooltip
      tip="im testing tooltip❤️"
      nudge-top="-30px"
      border-radius="2.7px"
      animation="swipe-top"
      boundingTarget="idk"
    ></ov-tooltip>
  </span>
</template>

<script>
export default {
  data: () => ({}),
  components: {},
  methods: {
    playSound: function() {
      var audio = new Audio(require(`@/theme/assets/songs/donde-estas.mp3`));
      audio.play();
    }
  }
};
</script>

<style scoped>
.MSG {
  position: relative;
  font-size: 50px;
  font-family: "Reem Kufi", sans-serif !important;
  float: left;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-shadow: 0, 0, 5px, 5px teal;
}
</style>
